import { LangDirType } from "helpers/language";
import { useRef } from "react";

type PropsType = {
  q: string;
  answer: string;
  onBackClicked?: () => void;
  dir: LangDirType;
};

export const ExtractedAnswer = ({
  q,
  answer,
  onBackClicked,
  dir,
}: PropsType) => {
  const headerTextRef = useRef<HTMLHeadingElement | null>(null);
  const queryTextClasses =
    "overflow-hidden text-ellipsis whitespace-nowrap base-bold text-fg-base";

  return (
    <div>
      <span className={queryTextClasses}>{q}</span>

      <div className="sparkle-box">
        <div className="flex px-4 py-3 mt-3" dir={dir}>
          <h2 className="flex-1 text-fg-base" ref={headerTextRef}>
            {answer}
          </h2>
        </div>
      </div>
    </div>
  );
};
